<cm-modal variant="large"
          (onClose)="onCancel()">
    <cm-modal-title>
        {{ 'MFA.CONFIGURE.CONFIGURE_MFA' | translate }}
    </cm-modal-title>
    <cm-modal-body>
        <div *ngIf="configureMFAData.showStep === secretKeyStep"
             class="configure-mfa-panel">
            <h4 class="header mb-5 text-center">
                {{ 'MFA.CONFIGURE.FIRST_STEP_TITLE' | translate }}
                <a target="_blank" rel="noopener noreferrer" [href]="authenticators.MICROSOFT">
                    {{ 'MICROSOFT' | translate }}
                </a>, 
                <a target="_blank" rel="noopener noreferrer" [href]="authenticators.GOOGLE">
                    {{ 'GOOGLE' | translate }}
                </a>
                {{ 'MFA.CONFIGURE.OR' | translate }}
                <a target="_blank" rel="noopener noreferrer" [href]="authenticators.AUTHY">
                    {{ 'AUTHY' | translate }}
                </a>)
            </h4>
            <div class="content">
                {{ 'MFA.CONFIGURE.FIRST_STEP_INFO' | translate }}
                <figure class="image">
                    <img src="{{configureMFAData.qrCodeSetupImageUrl}}"/>
                </figure>
            </div>
            <div class="separator">
                <span class="separator--text">{{ 'MFA.CONFIGURE.OR' | translate }}</span>
            </div>
            <div class="secret-key mb-4">
                <p class="content">{{ 'MFA.CONFIGURE.FIRST_STEP_INFO_1' | translate }} </p>
                <div *ngFor="let item of formattedManualEntryKeyArray">
                    <span class="box">{{ item }}</span>
                </div>
            </div>
        </div>
        
        <div *ngIf="configureMFAData.showStep === verifyTokenStep"
             class="configure-mfa-panel">
            <h4 class="header mb-5 text-center">{{ 'MFA.CONFIGURE.SECOND_STEP_TITLE' | translate }}</h4>
            <p class="second-step-content text-center mb-5 px-3">{{ 'MFA.CONFIGURE.SECOND_STEP_INFO' | translate }}</p>
            <form (ngSubmit)="onVerify()">
                <p *ngIf="configureMFAData.errorData.isError"
                   class="text-danger text-center mb-4">{{ 'MFA.CONFIGURE.ERROR_MESSAGE_MAIN' | translate }}</p>
                <div class="mfa-token-input mb-5">
                    <input type="text"
                           placeholder="XXXXXX"
                           class="form-control"
                           autofocus
                           maxlength="15"
                           name="mfaToken"
                           [(ngModel)]="mfaToken"/>
                </div>
            </form>
        </div>
    </cm-modal-body>
    <cm-modal-footer>
        <ng-container *ngIf="configureMFAData.showStep === secretKeyStep">
            <button type="button"
                    class="btn btn-outline-primary"
                    (click)="onCancel()">
                {{ 'MFA.CONFIGURE.CANCEL' | translate}}
            </button>
            <button type="button"
                    class="btn btn-primary"
                    (click)="onContinue()">
                {{ 'MFA.CONFIGURE.CONTINUE_ACTION' | translate}}
            </button>
        </ng-container>
        <ng-container *ngIf="configureMFAData.showStep === verifyTokenStep">
            <button type="button"
                    class="btn btn-outline-primary"
                    (click)="onCancel()">
                {{ 'MFA.CONFIGURE.CANCEL' | translate}}
            </button>
            <button type="button"
                    class="btn btn-primary"
                    [disabled]="!mfaToken?.trim()"
                    (click)="onVerify()">
                {{ isVerifying ? ('MFA.CONFIGURE.VERIFYING' | translate) : ('MFA.CONFIGURE.VERIFY' | translate)}}
            </button>
        </ng-container>
    </cm-modal-footer>
</cm-modal>